import {
  UpdateMspNotificationInput,
  UpdateMspNotificationInputOld,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";

//---------------------------NEW APIs-------------------------------------//
export const getMspResourceNotificationSettings = async () => {
  try {
    const url = "v2/controlCenter/msp_notifications";
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getMspUserNotificationSettings = async () => {
  try {
    const url = "v2/controlCenter/msp_user_notifications";
    const response = await axiosClient.get(`${url}`);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateMspResourceNotificationSettings = async ({
  data,
  notificationType,
}: UpdateMspNotificationInput) => {
  try {
    const url = `v2/controlCenter/msp_notification/notify_type/${notificationType}`;
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateMspUserNotificationSettings = async ({
  data,
  notificationType,
}: UpdateMspNotificationInput) => {
  try {
    const url = `controlCenter/msp_user_notification/notify_type/${notificationType}`;
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response?.data;
    if (resData?.success && resData?.statusCode === 200) {
      return resData?.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
//---------------------------NEW APIs-------------------------------------//

//---------------------------OLD DEPRECATED APIs-------------------------------------//
export const getMspNotificationSettings = async () => {
  try {
    const url = "/controlCenter/msp_notifications";

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};

export const updateMspNotificationSettings = async ({
  notificationType,
  notificationSound,
  notificationStatus,
  notifyMethods,
  notifyRoles,
}: UpdateMspNotificationInputOld) => {
  try {
    const url = `/controlCenter/update/msp_notification/notify_type/${notificationType}`;

    const data = {
      notification_status: notificationStatus,
      notification_sound: notificationSound,
      notify_roles: notifyRoles,
      notify_methods: notifyMethods,
    };
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    } else {
      throw new Error(resData?.message);
    }
  } catch (error) {
    throw error;
  }
};
//---------------------------OLD DEPRECATED APIs-------------------------------------//
